export const catalogConfigs = {
  title: {
    default: "GAONTECH",
    ko: "GAONTECH",
  },
  langSet: ["ko", "en"],
  pageMap: [
    { 
      name: "cover",
      outlets: ["cover1", "cover2"]
     },
    { name: "catalog-index" },
    {
      name: "company",
      outlets: [
        {
          name: "about",
          outlets: ["introduce", "management"]
        },
        "why",
        "history",
        "development",
        // "tech",
        {
          name: "cert",
          outlets: ["cert1", "cert2"]
        },
        "global",
      ]
    },
    {
      name: "technology",
      outlets: [
        {
          name: "intro",
          outlets: ["intro1", "intro2"]
        },
        {
          name: "overview",
          outlets: ["overview1", "overview2", "overview3", "overview4", "overview5", "overview6"]
        },
      ]
    },
    {
      name: "product",
      outlets: [
        "lineup",
        {
          name: "pce-ex",
          outlets: ["cont1", "cont2"]
        },
        {
          name: "pce-pex",
          outlets: ["cont1", "cont2"]
        },
        {
          name: "pch-phx",
          outlets: ["cont1", "cont2"]
        },
        {
          name: "d-type",
          outlets: ["cont1", "cont2", "cont3"]
        },
        {
          name: "pde-366",
          outlets: ["cont1", "cont2"]
        },
        {
          name: "pde-f",
          outlets: ["cont1", "cont2"]
        },
        {
          name: "pdh-271",
          outlets: ["cont1", "cont2"]
        },
        {
          name: "filter",
          outlets: ["cont1", "cont2", "cont3"]
        },
      ]
    },
    "last"
  ],
  autoplay: {
    delay: 8000,
    loop: true,
  },
  width: 1920,
  height: 1080,
  breakpoint: 768,
};

const ENV = process.env;
export const IS_DEV = ENV.REACT_APP_IS_DEV;
export const ROUTER_TYPE = ENV.REACT_APP_ROUTER_TYPE;
export const BASE_NAME = ENV.REACT_APP_BASE_NAME;
export const PUBLIC_URL = ENV.PUBLIC_URL;
export const IMG_URL = `${PUBLIC_URL}/images`;
